import type { Tour } from '../tour-types';

/**
 * Program: what concluded experiments taught. When nothing happened in the chosen window
 * the content is a first-run state under the filters, and the tour waits for a window
 * with something in it. The shared scope picker is left to the Health tour.
 */
export const programTour: Tour = {
  key: 'program',
  version: 1,
  routes: ['/program'],
  steps: [
    {
      anchor: 'program-window',
      placement: 'bottom',
      title: 'Look-back window',
      body: 'How many months back to look, ending with this one. Everything below counts only what launched or concluded in that window.',
    },
    {
      anchor: 'program-kpis',
      placement: 'bottom',
      title: 'The programme in numbers',
      body: 'How often tests win, by how much, how long they take, and how many winners actually shipped. Idea to launch is how long a draft waits before it starts.',
    },
    {
      anchor: 'program-velocity',
      placement: 'top',
      title: 'Velocity',
      body: 'Tests launched each month against how the concluded ones turned out. More launches without more wins means testing more without learning more.',
    },
    {
      anchor: 'program-breakdown',
      placement: 'top',
      title: 'What tends to win',
      body: 'Win rate by expected mechanism and by PXL importance, to check whether your prioritisation predicts results. Faded rows rest on too few results to trust.',
    },
    {
      anchor: 'program-concluded',
      placement: 'top',
      title: 'Concluded tests',
      body: 'Every test that ended in this window, with its outcome, lift and length. Open one to read its full result.',
    },
    {
      anchor: 'program-outcomes',
      placement: 'bottom',
      title: 'Filter by outcome',
      body: 'List only the tests that won, came out mixed, lost or were inconclusive. Mixed means one variant won while another lost.',
    },
  ],
};
